import { Controller } from 'react-hook-form';

import Field, { FieldProps } from 'ui/Field';
import Input from 'ui/Input';

import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import {
  getFieldMaxConstraint,
  getFieldMinConstraint,
} from '../../utils/validation';

type Props = Omit<FieldProps, 'form'> & {
  field: SankeyFormTextField;
  size?: 'sm' | 'md';
  label?: string;
};

const FormTextInput = ({ field: name, label, size, ...props }: Props) => {
  const { form } = useSankeyFormContext();
  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field, fieldState }) => (
        <Field
          label={label}
          invalid={fieldState.invalid}
          fontSize="xs"
          {...props}
        >
          <Input
            id={field.name}
            value={field.value ?? ''}
            onChange={field.onChange}
            minLength={getFieldMinConstraint(field.name)}
            maxLength={getFieldMaxConstraint(field.name)}
            size={size}
          />
        </Field>
      )}
    />
  );
};

export default FormTextInput;
